import { Component } from '@angular/core';

@Component({
  selector: 'app-fashion-go-button',
  imports: [],
  templateUrl: './fashion-go-button.html',
  styleUrl: './fashion-go-button.scss'
})
export class FashionGoButton {

}
